// Version gate: renders the persisted snapshot instantly, then checks
// /api/content-version in the background. When the server version moved
// (CMS edit re-warmed by 1-2 other users), invalidate locally so the fresh
// server data streams in without ever showing a loader.
"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { VERSION_STORAGE_KEY } from "./cache-tags";

export function useContentVersionSync(queryClient: any) {
  const router = useRouter();
  useEffect(() => {
    if (!queryClient) return;
    let cancelled = false;
    const stored =
      typeof window !== "undefined" ? window.localStorage.getItem(VERSION_STORAGE_KEY) : null;

    fetch("/api/content-version", { cache: "no-store" })
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        if (cancelled || !json?.version) return;
        if (stored && stored === json.version) return;
        try {
          window.localStorage.setItem(VERSION_STORAGE_KEY, json.version);
        } catch {}
        // Stale snapshot stays on screen; fresh queries refetch in background.
        queryClient.invalidateQueries();
        // Leaders (`layout.leaders`) + floor elevator (`layout.features-elevator`)
        // arrive via the `fetchByUrl` RSC prop (`apiData`), NOT a TanStack query,
        // so invalidateQueries() alone never refreshes them. Re-run the server
        // component in the background to pull the revalidated page payload.
        try {
          router.refresh();
        } catch {}
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [queryClient, router]);
}
